import ScrollGradient from './ScrollGradient';

export default ScrollGradient;
